import Banner from '@assets/banner/banner_2048x672.jpg';

export const Footer = () => {
    return (
        <div
            className="h-[350px] bg-cover bg-center"
            style={{ backgroundImage: `url(${Banner})` }}
        >
            {/* Image overlay */}
            <div className="w-full h-full bg-black/50 flex items-center"></div>
        </div>
    );
};